module.exports = __webpack_public_path__ + "fonts/free-fa-regular-400.4c57847.woff2";